export default __webpack_public_path__ + "static/media/Account-black.d73b7d30.svg";